import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setUser } from '../userSlice'; // import your Redux action to update token

// Simple function to check if JWT token is expired
const isTokenExpired = (token) => {
    if (!token) return true;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * 1000 < Date.now();
    } catch (err) {
        return true;
    }
};

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let token = api.getState().user?.token;
    console.log(token, "token");

    if (!token) {
        try {
            const root = JSON.parse(localStorage.getItem("persist:root"));
            if (root?.user) {
                const userObj = JSON.parse(root.user);
                token = userObj.token;
            }
        } catch (err) {
            console.error("Error parsing persist:root", err);
        }
    }

    // if this request requires auth, attach Authorization header
    if (args._auth) {
        if (!token) {
            console.warn("No token found in Redux Persist");
            return { error: { status: 401, data: "Unauthorized" } };
        }
        if (!args.headers) args.headers = {};
        args.headers.Authorization = `Bearer ${token}`;
    }

    const result = await baseQuery(args, api, extraOptions);

    // ⚠️ don’t remove token from localStorage here anymore,
    // since we’re relying on Redux Persist instead
    if (result.error && result.error.status === 401) {
        console.log("Unauthorized after request — redirecting to login");
        localStorage.removeItem("authtoken");
        localStorage.removeItem("refresh");
        // window.location.href = "/login"; // ⬅️ redirect
    }

    return result;
};



export const ApartmentApi = createApi({
    reducerPath: 'ApartmentApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Apartment'],
    endpoints: (builder) => ({
        // ---------- Queries ----------
        getAllAmenity: builder.query({ query: () => `/apartments/room-amenity` }),
        getAllamenities: builder.query({ query: () => `/apartments/amenities` }),
        getApartmentById: builder.query({ query: (id) => `/apartments/apartment/${id}` }),
        getAllApartments: builder.query({ query: () => `/apartments/apartment`, providesTags: ['Apartment'] }),
        // getAllApartments: builder.query({
        //     query: () => ({
        //         url: `/apartments/apartment`,
        //         _auth: true, // ✅ attach token for authenticated request
        //     }),
        //     providesTags: ['Apartment'],
        // }),

        getAllApartmentAmenity: builder.query({
            query: ({ page = 1, page_size = 10, ...filters }) => {
                const params = new URLSearchParams({ page, page_size, ...filters }).toString();
                return `/apartments/amenity?${params}`;
            },
            invalidatesTags: ['Apartment'],
        }),
        getAllApartmentFacilities: builder.query({ query: () => `/apartments/facility` }),
        getAllPaginatedApartmentFacilities: builder.query({
            query: ({ page = 1, page_size = 10, ...filters }) => {
                const params = new URLSearchParams({ page, page_size, ...filters }).toString();
                return `/apartments/paginated-facility?${params}`;
            },
            invalidatesTags: ['Apartment'],
        }),
        getAllapartmentsExtraservice: builder.query({ query: () => `/apartments/extra-service` }),
        getAllPagiantedapartmentsExtraservice: builder.query({
            query: ({ page = 1, page_size = 10, ...filters }) => {
                const params = new URLSearchParams({ page, page_size, ...filters }).toString();
                return `/apartments/paginated-extra-service?${params}`;
            },
            invalidatesTags: ['Apartment'],
        }),
        apartmentDetail: builder.query({ query: (id) => `/apartments/apartment/${id}` }),

        // ---------- Mutations ----------
        createApartment: builder.mutation({
            query: (newApartment) => ({
                url: `/apartments/apartment`,
                method: 'POST',
                body: newApartment,
                _auth: true, // only this request will send the token
            }),
            invalidatesTags: ['Apartment'],
        }),
        createApartmentAmenity: builder.mutation({
            query: (formData) => ({ url: '/apartments/amenity', method: 'POST', body: formData }),
            invalidatesTags: ['Apartment'],
        }),
        createApartmentFacility: builder.mutation({
            query: (data) => ({ url: '/apartments/facility', method: 'POST', body: data }),
            invalidatesTags: ['Apartment'],
        }),
        createExtraservice: builder.mutation({
            query: (formData) => ({ url: '/apartments/extra-service', method: 'POST', body: formData }),
            invalidatesTags: ['Apartment'],
        }),
        deleteApartmentFacilities: builder.mutation({
            query: (id) => ({ url: `/apartments/facility/${id}`, method: 'DELETE' }),
            invalidatesTags: ['Apartment'],
        }),
        deleteApartmentExtraervice: builder.mutation({
            query: (id) => ({ url: `/apartments/extra-service/${id}`, method: 'DELETE' }),
            invalidatesTags: ['Apartment'],
        }),
        deleteApartment: builder.mutation({
            query: (id) => ({ url: `/apartments/apartment/${id}`, method: 'DELETE' }),
            invalidatesTags: ['Apartment'],
        }),
        deleteApartmentAmenity: builder.mutation({
            query: (id) => ({ url: `/apartments/amenity/${id}`, method: 'DELETE' }),
            invalidatesTags: ['Apartment'],
        }),
        uploadApartmentImages: builder.mutation({
            query: (formData) => ({ url: '/apartments/images', method: 'POST', body: formData }),
        }),
        updateApartment: builder.mutation({
            query: ({ id, data }) => ({
                url: `/apartments/apartment/${id}`, // Make sure this matches your Django URL
                method: 'PUT',
                body: data,
                _auth: true,
            }),
            invalidatesTags: ['Apartment'],
        }),
        updateAmenity: builder.mutation({
            query: ({ id, data }) => ({
                url: `/apartments/amenity/${id}`,
                method: 'PUT',
                body: data,

            }),
            invalidatesTags: ['Apartment'],
        }),
        updateFacility: builder.mutation({
        query: ({ id, data }) => ({
            url: `/apartments/facility/${id}`,
            method: 'PUT',
            body: data,

        }),
        invalidatesTags: ['Apartment'],
    }),
        getAmenitybyId: builder.query({ query: (id) => `/apartments/amenity/${id}` }),
        getFacilityById: builder.query({ query: (id) => `/apartments/facility/${id}` }),

    }),
    
    
    

});

export const {
    useGetFacilityByIdQuery,
    useUpdateFacilityMutation,
    useGetAmenitybyIdQuery,
    useUpdateAmenityMutation,
    useUpdateApartmentMutation,
    useGetAllamenitiesQuery,
    useDeleteApartmentExtraerviceMutation,
    useDeleteApartmentFacilitiesMutation,
    useCreateExtraserviceMutation,
    useGetAllPagiantedapartmentsExtraserviceQuery,
    useCreateApartmentFacilityMutation,
    useGetAllPaginatedApartmentFacilitiesQuery,
    useCreateApartmentAmenityMutation,
    useDeleteApartmentAmenityMutation,
    useUploadApartmentImagesMutation,
    useApartmentDetailQuery,
    useDeleteApartmentMutation,
    useGetAllAmenityQuery,
    useGetAllapartmentAmenityQuery,
    useGetApartmentByIdQuery,
    useGetAllApartmentsQuery,
    useGetAllApartmentAmenityQuery,
    useCreateApartmentMutation,
    useGetAllApartmentFacilitiesQuery,
    useGetAllapartmentsExtraserviceQuery,
} = ApartmentApi;
